module.exports = __webpack_public_path__ + "img/4.796aa0b9.png";